if(!customElements.get('cart-discount')) {
  class CartDiscount extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.cart-discount__input');
      this.submitButton = this.querySelector('.cart-discount__submit');
      this.feedback = this.querySelector('.cart-discount__feedback');

      if(!this.input || !this.submitButton) return;
      
      this.submitButton.addEventListener('click', this.handleApplyCode.bind(this));
      this.input.addEventListener('keydown', (e) => {
        if(e.key === 'Enter') this.handleApplyCode();
      });

      this.querySelectorAll('.cart-discount__pill-remove').forEach((btn) => {
        btn.addEventListener('click', () => this.handleRemoveCode(btn.dataset.code));
      });
    }

    handleApplyCode() {
      const code = this.input.value.trim().toUpperCase();
      if(!code) {
        this.showFeedback('Please enter a valid code.', 'error');
        return
      }
      this.applyDiscount(code);
    }

    async applyDiscount(code) {
      const existingCodes = this.getAppliedCodes();
      const allCodes = [...existingCodes, code].join(',');

      this.setLoading(true);
      
      try {
        const response = await fetch(theme.routes.cartUpdate, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ discount: allCodes })
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.description || response.status);
        const result = data.discount_codes ? data.discount_codes.find(d => d.code.toUpperCase() === code.toUpperCase()) : null;
        if(result && result.applicable === false) {
          this.showFeedback('This discount code is not valid.', 'error');
        } else {
          this.input.value = '';
          this.showFeedback(`"${code}" applied successfully.`, 'success');
          this.refreshCart();
        }
      } catch (error) {
        this.showFeedback('Something went wrong. Please try again.', 'error');
        console.error(error);
      } finally {
        this.setLoading(false);
      }
    }
    
    async handleRemoveCode(code) {
      const existingCodes = this.getAppliedCodes();
      const allCodes = existingCodes.filter(c => c !== code);
      this.setLoading(true);
      try {
        const response = await fetch(theme.routes.cartUpdate, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ discount: allCodes.join(',') })
        });
        if (!response.ok) throw new Error(response.status);
        this.showFeedback('', '');
        this.refreshCart();
      } catch (error) {
        this.showFeedback('Could not remove discount. Please try again.', 'error');
        console.error(error);
      } finally {
        this.setLoading(false);
      }
    }

    refreshCart() {
      const cartItems = document.querySelector('cart-items');
      if (cartItems) cartItems.refresh();
    }

    getAppliedCodes() {
      return Array.from(this.querySelectorAll('.cart-discount__pill-remove'))
        .map(btn => btn.dataset.code)
        .filter(Boolean);
    }

    setLoading(isLoading) {
      this.submitButton.disabled = isLoading;
      this.submitButton.textContent = isLoading
        ? (this.submitButton.dataset.loadingText || 'Applying...')
        : (this.submitButton.dataset.defaultText || 'Apply');
    }

    showFeedback(message, type) {
      this.feedback.textContent = message;
      this.feedback.className = 'cart-discount__feedback';
      if (type) this.feedback.classList.add(`cart-discount__feedback--${type}`);
    }
  }
  customElements.define('cart-discount', CartDiscount);
}
